module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJVJREFUOE/dklEOwiAQRGfwBJ5IvFLjv3ABrySeCC9gx9CWxBBaIvXL/YTM27ewxM7izjx+ALhEixevXSbUgxiim8PfQuRhEIjhKUAet6ObYQ2QEHCQn6wJuwDyAPKbNkbn6X7kPScKQDqu2BRdP9+rAihsDAJG2LXRNgALKHVnAtSrDWj8738AooN46lrltL+9wZx7A54RQR5Fpy8vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/em.png
// module id = QQHu
// module chunks = 21